import React, {useState, useEffect, useRef } from 'react'
//import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import moment from 'moment'
import "../styles/react-big-calendar.css"
import styles from '../styles/Calender.module.css'
import * as firebase from 'firebase';
import { getCurrentUser } from '../firebaseConfig';
import CalenderItems from '../pages/Calendar/CalendarItems'
import Header from './LoginContent/HeaderLogin';
//const localizer = momentLocalizer(moment)
let randomize = require('randomatic');

const Calender = props => {

    const [allEvents, setAllEvents] = useState();

    const [show, setShow] = useState(false);
    const [showEvent, setShowEvent] = useState(false);

    const [eventInfoTitle, setEventInfoTitle] = useState();
    const [eventInfo, setEventInfo] = useState();
    const [showDeleteButton, setShowDeleteButton] = useState(false);
    //const [user, setUser] = useState('')
    const [userTopic, setUserTopic] = useState('')
    const [startDate, setStartDate] = useState();
    //const [endDate, setEndDate] = useState();
    
    const [userID, setUserID] = useState(''); //userID from logged user
    const [logged, setLogged] = useState(false)
    
    const [getRandom, setGetRandom] = useState("");

    let random = randomize('Aa0', 30); // generating random 30 letters
    //console.log("random", random)

    // best way to check for mounted component !!
    const isCurrent = useRef(true);

    useEffect(() => {
        return () => {
            isCurrent.current = false;
        }
    }, [])

    useEffect(() => {
        if (!getRandom) {
            if (isCurrent.current) { setGetRandom(random) }
            console.log(getRandom)
        }
    }, [])

        //getting current user ID
    useEffect(() => {
        getCurrentUser()
        .then((user) => {
            if (user != null) {
                console.log(user)
                console.log("[home.tsx] - " + user.uid);
                setUserID(user.uid)
                //if (isCurrent.current) { setLogged(true) }
                setLogged(true)
                //getDataFirebase(user.uid)
            } else {
                //if (isCurrent.current) { setLogged(false) }
                setLogged(false)
                console.log("not logged in")
                //history.push("/");
            }
        })
    }, [getRandom])

    // get DATA from firebase - NOT LOGGED
    const getDataFirebase = () => {
        //let array: any;
        let data;
        //console.log("checking how many times it renders !!")
        // getting data from location for WEIGHT
        let getData = firebase.database().ref('/calendar/');
        getData.on('value', function(snapshot) {
        console.log(snapshot.val());
        data = snapshot.val();
        if (data !== null) {
            // getting data to correct form ID:, DATE:, WEIGHT:
            const allCalendarArray = Object.keys(data).map( key => {
            // const start = (data[key].start + 900)*1000
            // const end = data[key].end*1000
            // console.log(start)
            // console.log(end)
            const checkTitle = () => {
                if (logged) {
                    return data[key].title;
                } else if (data[key].ids = getRandom) {
                    return data[key].title;
                } else {
                    return "Zasedeno"
                }
            }
            return  {
                // dates are in EPOCH time - convert it + always 15 min apart (+ 900)!!
                did: key,
                ids: data[key].ids,
                start: new Date(data[key].start*1000),
                end: new Date((data[key].start + 900)*1000),
                title: checkTitle(),
                };
            })
            // checking for componenet is mounted !!
            if (isCurrent.current) { setAllEvents(allCalendarArray) }
        }
        })
    }
    //function to write data to firebase
    function writeDataCalendar(someData) {
        //getting unique KEY and push it - child node "glucose"
        let newPostKey = firebase.database().ref('calendar/').push().key;
        // what data is
        let updates = {}
        updates[newPostKey] = someData;
        // and finaly UPDATE the database - DONT USE .SET, or u DELETE everything else !!
        return firebase.database().ref('calendar/').update(updates);
    }

    
    useEffect(() => {
        getDataFirebase()  //userID - WITHOUT = not logged in  );
    }, [logged]) //userID
    
    //let title = null;
    const handleSelect = ({ start, end}) => {
        console.log("onClickHandler")
        console.log(start + " : " + end)
        const epochStart = start / 1000;
        //const epochEnd = end / 1000;
        //if (isCurrent.current) { setEndDate(epochEnd) }
        if (isCurrent.current) { setStartDate(epochStart) }
        
        const diffMs = (end - start); // milliseconds between start and end
        //const diffDays = Math.floor(diffMs / 86400000); // days
        //const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
        console.log(diffMins);
        if (diffMins === 15) {
            let checkCal = allEvents.filter((each) => each.start/1000 === epochStart) 
            console.log(checkCal);
            if (checkCal !== "undefined" && checkCal !== null && checkCal.length !== null && checkCal.length > 0) {
              console.log("arrey JE")
              if (isCurrent.current) { setShowEvent(true) }
            } 
            else {
              console.log("arrey NI")
              setShow(true)
            }
        } else {
            console.log("Izberete lahko samo 1 termin");
            //toast("Izberete lahko samo 1 termin")
        }
    }
    const onNoClickHandler = () => {
        console.log("on-NO-ClickHandler")
        //setEndDate(null) //???
        setStartDate(null); //???
        setShow(false);
    }
    const onYesClickHandler = () => {
        const checkIds = () => {
            if (userID) {
                return userID
            } else {
                return getRandom
            }
        }
        console.log("on-YES-ClickHandler")
        const newEventCalendar = {
            start: startDate,
            //end: endDate,
            title: userTopic,
            ids: checkIds()
        }
        
        // const newEvents = [...allEvents, newEvent]
        // setAllEvents(newEvents);
        writeDataCalendar(newEventCalendar)
        console.log("Uspešno ste se naročili")
        setShow(false);
    }

    useEffect(() => {
        console.log(allEvents)
        console.log(getRandom)
    }, [allEvents])

    const handleEventSelect = (getEvent, target) => {
        //e.preventDefault();
        console.log(target.currentTarget)
        console.log("clicked on event")
        setEventInfo(getEvent)
        setEventInfoTitle(getEvent.title);
        console.log(getEvent)
        const eventStart = getEvent.start / 1000
        let checkCal = allEvents.filter((each) => each.start/1000 === eventStart) 
        console.log(checkCal);
        if (checkCal !== "undefined" && checkCal !== null && checkCal.length !== null && checkCal.length > 0) {
          console.log("event JE")
          setShowEvent(true)
        } 
        else {
          console.log("event NI")
        }
        // show button if its same as USERID or user not logged in but has same randomID
        if (getEvent.ids === userID || getEvent.ids === getRandom) {
          setShowDeleteButton(true);
        }
    }
  
    const onEventHandler = () => {
        console.log("on-Event-Zapri-Handler")
        setShowEvent(false);
        setShowDeleteButton(false);
    }
    const onDeleteEventHandler = () => {
        const events = [...allEvents]
        const idx = events.indexOf(eventInfo)
        // console.log(idx)
        // console.log(allEvents[idx])
        const singleEvent = allEvents[idx];
        //const event = eventInfo
        console.log(singleEvent.did)
        if (singleEvent.ids === userID ) {
            // show button if its same as USERID or user not logged in but has same randomID
            let removeData = firebase.database().ref('calendar/' + singleEvent.did);
            removeData.remove()
            console.log("Vrednost odstranjena userID");
            setShowDeleteButton(false);  
        } else if (singleEvent.ids === getRandom) {
            let removeData = firebase.database().ref('calendar/' + singleEvent.did);
            removeData.remove()
            console.log("Vrednost odstranjena randomIDS");
            setShowDeleteButton(false);
        } else {
            console.log("not logged in to delete")
        }
        setShowEvent(false);
        setShowDeleteButton(false);
    }

    // POPUP for NEW EVENT
    let popup = null;
    if (show) {
        popup = ( 
            <div className={styles.Popup}>
                <div className={styles.InPopup}>
                    <p>Vpišite vaše ime</p>
                    <input
                        type='text'
                        placeholder='Vaše ime...'
                        value={userTopic}
                        onChange={(e) => setUserTopic(e.target.value)}
                    />
                    <div className={styles.Buttons}>
                        <div className={styles.Button} onClick={onYesClickHandler}>OK</div>
                        <div className={styles.Button} onClick={onNoClickHandler}>Prekliči</div>
                    </div>
                </div>
            </div>
        )
    }

    // POPUP for existing EVENT
    let popupEvent = null;
    if (showEvent) {
        popupEvent = ( 
            <div className={styles.Popup}>
                <div className={styles.InPopup}>
                    <p>{eventInfoTitle}</p>
                    <p>Dne <strong>{moment(eventInfo.start).format('DD.MM.YYYY')}</strong></p>
                    <p>Ob <strong>{moment(eventInfo.start).format('hh:mm')}</strong></p>
                    <div className={styles.Buttons}>
                        <div className={styles.Button} onClick={onEventHandler}>OK</div>
                        { showDeleteButton ? 
                            <div className={styles.Button} onClick={onDeleteEventHandler} >Izbriši</div> :
                            null }
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.Main}>
            <Header isLogged={logged} />
            {popup}
            {popupEvent}
            <CalenderItems
                isLogged={logged}
                //calViews={calViews}
                eventSelect={handleEventSelect}
                select={handleSelect}
                allEvents={allEvents}  />
        </div>
    )
}

export default Calender;